<template>

  <div class="container page pwd-page">

    <van-nav-bar :title="$t('setting.modify_real_name')" class="nav-bar" :border="false">

      <template #left>

        <van-icon name="arrow-left" @click="back()" />

      </template>

      <template #right>

        <span class="nav-right" @click="save()">{{ $t('setting.save') }}</span>

      </template>

    </van-nav-bar>

    <div class="pwd-form">

      <div class="pwd-row van-hairline--bottom">

        <span class="pwd-label">{{ $t('setting.name') }}</span>

        <input

          v-model="name"

          class="pwd-input"

          type="text"

          :placeholder="$t('setting.name_place')"

        />

      </div>

    </div>

    <p class="name-tip">{{ $t('setting.name_tip') }}</p>

  </div>

</template>



<script>

export default {

  data() {

    return {

      name: '',

      userInfo: {}

    }

  },

  methods: {

    back() {

      window.history.back()

    },

    save() {

      if (!this.name) {

        this.$toast.fail(this.$t('setting.name_place'))

        return false

      }

      if (this.userInfo.name && this.name === this.userInfo.name) {

        this.$toast(this.$t('setting.repect'))

        return true

      }

      this.$http({

        method: 'get',

        data: { name: this.name },

        url: 'user_set_name'

      }).then(res => {

        if (res.code === 200) {

          this.getUserInfo()

          this.$toast(res.msg)

        } else if (res.code === 401) {

          this.$toast(res.msg)

        }

      })

    },

    getUserInfo() {

      this.$http({ method: 'get', url: 'user_info' }).then(res => {

        if (res.code === 200) {

          this.userInfo = res.data

          this.name = res.data.name

        } else if (res.code === 401) {

          this.$toast(res.msg)

        }

      })

    }

  },

  created() {

    if (!localStorage.getItem('token')) {

      this.$router.push({ path: '/Login' })

    } else {

      this.getUserInfo()

    }

  }

}

</script>



<style lang="less" scoped>

@import '../../assets/css/base.css';

.name-tip {

  padding: 12px 16px;

  margin: 0;

  font-size: 13px;

  color: #999;

  line-height: 1.6;

}

.pwd-form .pwd-input {

  text-align: left;

}

</style>

